import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import Check from '../../SidePanel/RightPanel/PropertiesControllerCheck.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Password from '../../SidePanel/RightPanel/PropertiesControllerPassword.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import DbInsStatus from './DbInsStatus.mjs'
import Model from './ModelDbins.mjs'
import Driver from './PropertiesControllerDriver.jsx'
import Url from './PropertiesControllerUrl.jsx'

const PropertiesPaneDbins = (props) => (
    <ComponentPropertiesPane
        controllers={
            <>
                <Text prop="dbInsName" />
                <LongText prop="dbInsDesc" />
                <LongText prop="dbInsMemo" />
                <Text prop="dbInsVersion" />

                <Check
                    falseValue={0}
                    trueValue={1}
                    prop="dbDefault"
                />

                <Text prop="dbInsIntranetIp" />
                <Text prop="dbInsPort" />
                <Text prop="dbInsSchema" />
                <Text prop="dbInsUserName" />

                <Password
                    autocomplete="new-password"
                    prop="dbInsUserPassword"
                />

                <Driver />
                <Url />

                <Select
                    options={DbInsStatus}
                    prop="dbInsStatus"
                />

                <Text prop="dbInsBu" />
                <Text prop="dbInsDm" />
                <Text prop="dbInsOm" />
                <Text prop="dbInsEnv" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneDbins
